import React from "react";

const EmailIconSVG = ({ sx }) => {
  return (
    <svg
      width="22"
      height="18"
      viewBox="0 0 22 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ ...sx }}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.69358 3.21616e-07H12.8064C14.6442 -1.55332e-05 16.0998 -2.81632e-05 17.239 0.153135C18.4114 0.310763 19.3604 0.64288 20.1088 1.39124C20.8571 2.13961 21.1892 3.08856 21.3469 4.26098C21.5 5.40019 21.5 6.85583 21.5 8.69359V8.80641C21.5 10.6442 21.5 12.0998 21.3469 13.239C21.1892 14.4114 20.8571 15.3604 20.1088 16.1088C19.3604 16.8571 18.4114 17.1892 17.239 17.3469C16.0998 17.5 14.6442 17.5 12.8064 17.5H8.69359C6.85583 17.5 5.40019 17.5 4.26098 17.3469C3.08856 17.1892 2.13961 16.8571 1.39124 16.1088C0.64288 15.3604 0.310763 14.4114 0.153135 13.239C-2.81632e-05 12.0998 -1.55332e-05 10.6442 3.21616e-07 8.80642V8.69358C-1.55332e-05 6.85582 -2.81632e-05 5.40019 0.153135 4.26098C0.310763 3.08856 0.64288 2.13961 1.39124 1.39124C2.13961 0.64288 3.08856 0.310763 4.26098 0.153135C5.40019 -2.81632e-05 6.85582 -1.55332e-05 8.69358 3.21616e-07ZM4.46085 1.63976C3.45476 1.77502 2.87511 2.02869 2.4519 2.4519C2.02869 2.87511 1.77502 3.45476 1.63976 4.46085C1.50159 5.48851 1.5 6.84318 1.5 8.75C1.5 10.6568 1.50159 12.0115 1.63976 13.0392C1.77502 14.0452 2.02869 14.6249 2.4519 15.0481C2.87511 15.4713 3.45476 15.725 4.46085 15.8602C5.48851 15.9984 6.84318 16 8.75 16H12.75C14.6568 16 16.0115 15.9984 17.0392 15.8602C18.0452 15.725 18.6249 15.4713 19.0481 15.0481C19.4713 14.6249 19.725 14.0452 19.8602 13.0392C19.9984 12.0115 20 10.6568 20 8.75C20 6.84318 19.9984 5.48851 19.8602 4.46085C19.725 3.45476 19.4713 2.87511 19.0481 2.4519C18.6249 2.02869 18.0452 1.77502 17.0392 1.63976C16.0115 1.50159 14.6568 1.5 12.75 1.5H8.75C6.84318 1.5 5.48851 1.50159 4.46085 1.63976ZM4.17383 4.26986C4.43901 3.95165 4.91193 3.90866 5.23014 4.17383L7.38903 5.97291C8.32199 6.75038 8.96973 7.28842 9.51658 7.64013C10.0459 7.98059 10.4049 8.09488 10.75 8.09488C11.0951 8.09488 11.4541 7.98059 11.9834 7.64013C12.5303 7.28842 13.178 6.75038 14.111 5.97291L16.2699 4.17383C16.5881 3.90866 17.061 3.95165 17.3262 4.26986C17.5913 4.58807 17.5483 5.06099 17.2301 5.32617L15.0336 7.15658C14.1473 7.89523 13.4289 8.49392 12.7948 8.90172C12.1343 9.32653 11.4911 9.59488 10.75 9.59488C10.0089 9.59488 9.36567 9.32653 8.70518 8.90172C8.07112 8.49392 7.35272 7.89524 6.46636 7.15658L4.26986 5.32617C3.95165 5.06099 3.90866 4.58807 4.17383 4.26986Z"
        fill="url(#paint0_linear_128_3448)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_128_3448"
          x1="10.75"
          y1="2.19686e-07"
          x2="16.75"
          y2="17.75"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#2756AA" />
          <stop offset="1" stopColor="#AF1222" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default EmailIconSVG;
